<span
    [class]="'split-icon '+ classes"
    [innerHTML]="path"
    [style.height.px]="size"
    [style.width.px]="size">
</span>